import { call, all, takeEvery, put, fork } from 'redux-saga/effects';
import { notification } from '@isomorphic/shared/isomorphic/components';
import actions from './actions';
import SuperFetch from '../../helpers/superFetch';

export function* userGroups() {
  yield takeEvery(actions.USERGROUP_SEARCH, function*({ queryString }) {
    console.log('GET UserGroups queryString:');
    console.log(JSON.stringify(queryString));
    const response = yield call(SuperFetch.get, 'usergroup?' + queryString);
    console.log('RESPONSE UserGroups:');
    console.log(JSON.stringify(response));
    if (response.Status !== 'error' && !response.error) {
      let userGroups = response.Data.UserGroups;
      yield put({
        type: actions.USERGROUP_SEARCH_SUCCESS,
        userGroups: userGroups,
      });
    } else {
      yield put({
        type: actions.USERGROUP_ERROR,
        userGroupError: Math.floor(Date.now() / 1000),
      });
      yield notification('error', response.Message, '', true); //allow silent if server error
    }
  });
}

export function* userGroupUsers() {
  yield takeEvery(actions.USERGROUP_USERS, function*({ queryString }) {
    console.log('GET users queryString:');
    console.log(JSON.stringify(queryString));
    const response = yield call(SuperFetch.get, 'user?' + queryString);
    console.log('RESPONSE users:');
    console.log(JSON.stringify(response));
    if (response.Status !== 'error' && !response.error) {
      let users = response.Data.Users;
      yield put({
        type: actions.USERGROUP_USERS_SUCCESS,
        userGroupUsers: users,
      });
    } else {
      yield put({
        type: actions.USERGROUP_ERROR,
        userError: Math.floor(Date.now() / 1000),
      });
      yield notification('error', response.Message, '', true);
    }
  });
}

export function* userGroupCreate() {
  yield takeEvery(actions.USERGROUP_CREATE, function*({ createdUserGroup }) {
    let userGroups = [];
    userGroups.push(createdUserGroup);
    const data = { Data: { UserGroups: userGroups } };
    console.log('POST usergroup/create json:');
    console.log(JSON.stringify(data));
    const response = yield call(SuperFetch.post, 'usergroup/create', data);
    console.log('RESPONSE usergroup/create:');
    console.log(JSON.stringify(response));
    if (response.Status !== 'error' && !response.error) {
      let userGroupCreateSuccess = response.Data.UserGroups;
      yield put({
        type: actions.USERGROUP_CREATE_SUCCESS,
        userGroupCreateSuccess: userGroupCreateSuccess,
      });
    } else {
      yield put({
        type: actions.USERGROUP_ERROR,
        userGroupError: Math.floor(Date.now() / 1000),
      });
      yield notification('error', response.Message);
    }
  });
}

export function* userGroupUpdate() {
  yield takeEvery(actions.USERGROUP_UPDATE, function*({ updatedUserGroup }) {
    let userGroups = [];
    userGroups.push(updatedUserGroup);
    const data = { Data: { UserGroups: userGroups } };
    console.log('POST usergroup/update json:');
    console.log(JSON.stringify(data));
    const response = yield call(SuperFetch.post, 'usergroup/update', data);
    console.log('RESPONSE usergroup/update:');
    console.log(JSON.stringify(response));
    if (response.Status !== 'error' && !response.error) {
      let userGroupUpdateSuccess = response.Data.UserGroups;
      yield put({
        type: actions.USERGROUP_UPDATE_SUCCESS,
        userGroupUpdateSuccess: userGroupUpdateSuccess,
      });
    } else {
      yield put({
        type: actions.USERGROUP_ERROR,
        userGroupError: Math.floor(Date.now() / 1000),
      });
      yield notification('error', response.Message);
    }
  });
}

export function* userGroupDelete() {
  yield takeEvery(actions.USERGROUP_DELETE, function*({ deletedUserGroup }) {
    var queryString = 'ID=' + deletedUserGroup.ID;
    console.log('POST usergroup/delete queryString:');
    console.log(JSON.stringify(queryString));
    const response = yield call(
      SuperFetch.delete,
      'userGroup/delete?' + queryString
    );
    if (response.Status !== 'error' && !response.error) {
      let userGroupDeleteSuccess = deletedUserGroup;
      yield put({
        type: actions.USERGROUP_DELETE_SUCCESS,
        userGroupDeleteSuccess: userGroupDeleteSuccess,
      });
    } else {
      yield put({
        type: actions.USERGROUP_ERROR,
        userGroupError: Math.floor(Date.now() / 1000),
      });
      yield notification('error', response.Message);
    }
  });
}

/*
Saga loader
*/
export default function* rootSaga() {
  yield all([
    fork(userGroups),
    fork(userGroupUsers),
    fork(userGroupCreate),
    fork(userGroupUpdate),
    fork(userGroupDelete),
  ]);
}
